import React from 'react';
import {
  Radar, RadarChart, PolarGrid, PolarAngleAxis,
  PolarRadiusAxis, ResponsiveContainer, Tooltip
} from 'recharts';

export interface RadarScoreItem {
  subject: string;
  A: number;
  fullMark: number;
}

interface RadarScoreChartProps {
  data: RadarScoreItem[];
  overallScore?: number;
  overallMax?: number;
}

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div style={{
        background: '#fff', padding: '8px 12px',
        border: '1px solid #e2e8f0', borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.05)', fontSize: '12px'
      }}>
        <p style={{ margin: 0, fontWeight: 700, color: '#0f172a' }}>{label}</p>
        <p style={{ margin: 0, color: '#0d6e5b', fontWeight: 600 }}>
          Score: {payload[0].value} / {payload[0].payload.fullMark}
        </p>
      </div>
    );
  }
  return null;
};

const RadarScoreChart: React.FC<RadarScoreChartProps> = ({ data, overallScore, overallMax = 10 }) => {
  const pct = overallScore != null ? Math.round((overallScore / overallMax) * 100) : null;

  return (
    <div style={{ width: '100%', height: 230, position: 'relative' }}>
      <ResponsiveContainer>
        <RadarChart cx="50%" cy="50%" outerRadius="70%" data={data}>
          {/* @ts-ignore */}
          <PolarGrid
            stroke="#d1d5db"
            strokeDasharray="0"
            gridType="polygon"
          />
          {/* @ts-ignore */}
          <PolarAngleAxis
            dataKey="subject"
            tick={{ fill: '#374151', fontSize: 11, fontWeight: 700 }}
          />
          {/* @ts-ignore */}
          <PolarRadiusAxis
            domain={[0, data[0]?.fullMark || 10]}
            tick={false}
            axisLine={false}
          />
          {/* @ts-ignore */}
          <Tooltip content={<CustomTooltip />} />
          {/* @ts-ignore */}
          <Radar
            name="Candidate"
            dataKey="A"
            stroke="#0d6e5b"
            strokeWidth={2}
            fill="#0d6e5b"
            fillOpacity={0.25}
            isAnimationActive={false}
          />
        </RadarChart>
      </ResponsiveContainer>

      {/* Center overall score badge */}
      {pct != null && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          background: '#ffffff',
          border: '2px solid #e2e8f0',
          borderRadius: '50%',
          width: 64,
          height: 64,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
          pointerEvents: 'none'
        }}>
          <span style={{ fontSize: 16, fontWeight: 800, color: '#0f172a', lineHeight: 1 }}>{pct}%</span>
          <span style={{ fontSize: 8, fontWeight: 700, color: '#94a3b8', letterSpacing: '0.5px', marginTop: 2 }}>OVERALL</span>
        </div>
      )}
    </div>
  );
};

export default RadarScoreChart;
